<template>
  <button
    :class="[variant, {
      'arrow-right': arrowRight,
      'disabled': disabled
    }]"
    :type="type"
    @click="onClickButton"
  >
    {{ text }}
  </button>
</template>

<script>
export default {
  name: 'ProaServiceButton',
  props: {
    variant: {
      type: String,
      default: 'primary round'
    },
    type: {
      type: String,
      default: 'button'
    },
    text: {
      type: String,
      default: 'button'
    },
    arrowRight: Boolean,
    disabled: Boolean,
    to: String
  },
  methods: {
    onClickButton: function() {
      if (!this.to) return
      this.$router.push({ path: this.to })
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

button {
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  outline: none;
  background-color: transparent;
  border: none;
  font-size: 16px;
  font-weight: bold;
  margin: 0;
  transition: all .2s;
  word-break: keep-all;

  &:hover:not(.disabled) {
    opacity: .6;
  }

  &.disabled {
    cursor: default;
    opacity: .5;
  }

  &.round {
    border-radius: 30px;
    width: 260px;
    height: 60px;
  }

  &.square{
    font-size: 15px;
    border-radius: 4px;
    width: 300px;
    height: 60px;

    @include mq(lg) {
      width: 335px;
    }
  }

  &.primary {
    color: white;
    background-color: $service-primary-color;
  }

  &.outline-primary {
    color: $service-primary-color;
    border: 2px solid $service-primary-color;
    background-color: white;
  }

  &.outline-secondary {
    color: $secondary-color;
    border: 1px solid $secondary-color;
    background-color: white;
  }

  &.outline-white {
    color: white;
    border: 2px solid white;
    background-color: $service-primary-color;
  }

  &.arrow-right {
    position: relative;

    &:after {
      content: '';
      position: absolute;
      width: 10px;
      height: 10px;
      border: 0px;
      border-top: solid 1px;
      border-right: solid 1px;
      transform: rotate(45deg);
      top: 50%;
      right: 20px;
      margin-top: -5px;
    }
  }
}
</style>
